
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.3301',
  depVersions: {
  "customer-portal-app": "static-1.3301",
  "apollo-dlb": "static-3.98",
  "client-types": "static-1.505",
  "data-fetching-client": "static-1.10059",
  "emoji-mart": "static-3.6",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.26392",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6003",
  "hs-test-utils": "static-1.8452",
  "hub-http": "static-1.6623",
  "hub-http-shared-msw-handlers": "static-1.10802",
  "hubspot-dlb": "static-2.1911",
  "hubspot-prosemirror": "static-1.19175",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11904",
  "I18n": "static-7.1691",
  "immutable": "static-2.88",
  "jasmine-runner": "static-1.6861",
  "payment-link-components": "static-1.24332",
  "portals-platform-bend-plugin": "static-1.25",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7587",
  "quartz-core": "static-1.6806",
  "quartz-i18n": "static-1.1262",
  "react": "static-7.202",
  "react-colorpicker": "static-2.10626",
  "react-dlb": "static-1.92",
  "react-utils": "static-2.5622",
  "reselect": "static-3.15",
  "rich-text-lib": "static-1.20466",
  "transmute": "static-2.97",
  "ui-addon-upgrades": "static-9.18508",
  "ui-components-test-utils": "static-1.6041",
  "UIComponents": "static-3.8850",
  "foundations-assets": "static-1.5300",
  "foundations-components": "static-1.8655",
  "foundations-theming": "static-1.4895",
  "foundations-theming-specialty": "static-1.2611",
  "framer-motion": "static-1.83",
  "metrics-js": "static-1.9990",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1622",
  "quartz-config": "static-1.1365",
  "quartz-routing": "static-1.1017",
  "quick-fetch": "static-1.4191",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1-fix-undefined-routespec-crash.10",
  "rpc-client-utils": "static-1.5082",
  "sanitize-text": "static-1.8571",
  "styled-components": "static-2.100",
  "tanstack-table": "static-1.65",
  "ui-addon-draggable": "static-3.5159",
  "ui-addon-react-router-dom": "static-1.9943",
  "usage-tracker": "static-1.7727",
  "usage-tracker-anonymous": "static-1.6144",
  "usage-tracker-core": "static-1.7577",
  "video-components-external": "static-1.12325",
  "apollo-stack-hubspot": "static-3.94",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3864",
  "quartz-webpack": "static-1.3811",
  "bend-plugin-quartz-routing": "static-1.665",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.92",
  "customer-data-objects": "static-1.8106",
  "frontend-preferences-client": "static-1.8332",
  "laboratory-lib": "static-3.7564",
  "onboarding-scopes": "static-1.6865",
  "seat-types-lib": "static-1.937",
  "ui-addon-opt": "static-4.8793",
  "HeadJS": "static-2.811",
  "hs-test-utils-bend-plugin": "static-1.3563",
  "msw": "static-1.39",
  "msw-config": "static-1.17",
  "testing-library": "static-1.163",
  "hs-locale-management": "static-1.361",
  "ts-schema": "static-1.4360",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8340",
  "content-media-capture": "static-1.5668",
  "cssUtils": "static-1.1034",
  "customer-data-ui-utilities": "static-1.10245",
  "file-manager-components": "static-1.24737",
  "HubStyle": "static-2.12211",
  "knowledge-content-types": "static-1.8699",
  "PatternValidationJS": "static-1.3301",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.512",
  "ui-addon-emoji-picker": "static-1.10281",
  "ui-addon-i18n": "static-1.11560",
  "ui-business-units-lib": "static-1.9508",
  "ui-shepherd-react": "static-3.10687",
  "video-data-lib": "static-1.35983",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4722",
  "commerce-tours-lib": "static-1.6778",
  "customer-data-properties": "static-1.52877",
  "getting-started-shared-tasks": "static-1.19459",
  "growth-onboarding-reliability": "static-1.5496",
  "onboarding-tours": "static-1.17304",
  "reference-resolvers-lite": "static-1.8519",
  "sales-checkout-service-client": "static-1.3943",
  "ui-addon-iframeable": "static-1.9492",
  "user-context": "static-1.5477",
  "bender-build-tools": "static-1.3513",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.896",
  "hubspotter-http": "static-1.4927",
  "icons": "static-2.699",
  "mobile-manifest-mixins": "static-1.593",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.573",
  "quartz-auth": "static-1.1262",
  "quartz-head": "static-1.1252",
  "quartz-test": "static-1.1262",
  "quartz-tracking": "static-1.966",
  "trellis-components": "static-1.2960",
  "ui-fonts": "static-1.1166",
  "usage-tracker-container": "static-1.7717",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9839",
  "data-token-picker": "static-1.17042",
  "FileManagerLib": "static-1.40377",
  "property-translator": "static-1.5794",
  "merchandise-lib": "static-1.283",
  "purchase-motions-components": "static-1.6557",
  "SharedI18nStrings": "static-1.186",
  "foundations-components-test-utils": "static-1.6138",
  "react-create-root-preference": "static-1.88",
  "react-select-plus": "static-1.117",
  "react-virtualized": "static-2.111",
  "ui-images": "static-2.1269",
  "bend-plugin-foundations-components": "static-1.4924",
  "floating-ui": "static-1.67",
  "react-aria": "static-1.76",
  "trellis-assets": "static-1.2941",
  "bend-plugin-foundations-theming": "static-1.3378",
  "foundations-theming-base": "static-1.3880",
  "stylex": "static-1.45",
  "pdf-js": "static-2.49",
  "interframe": "static-3.5155",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.6141",
  "opentelemetry-fe-types": "static-1.198",
  "web-vitals": "static-1.18",
  "bend-plugin-chirp-manifest": "static-1.492",
  "chirp-fetch": "static-1.2313",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4885",
  "react-flip-move": "static-1.82",
  "apollo-link-hub-http": "static-2.5019",
  "content-media-composition-data-lib": "static-1.13472",
  "content-media-compositions": "static-2.17479",
  "idb-keyval": "static-1.54",
  "immer": "static-1.104",
  "immerable": "static-1.4556",
  "magpie-lib": "static-1.5850",
  "magpie-types": "static-1.5310",
  "media-bridge-lib": "static-1.19554",
  "inbound-db-properties-service-client": "static-1.4109",
  "superstore": "static-1.5172",
  "feedback-loader": "static-1.29972",
  "ai-components-ui-library": "static-1.9920",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29503",
  "ContentUtils": "static-1.69339",
  "fix-webm-duration": "static-1.33",
  "notification-sounds": "static-1.4839",
  "sassPrefix": "static-1.302",
  "react-dnd-compat": "static-1.5025",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.2003",
  "copilot-toolkit": "static-1.12041",
  "poll-commands": "static-1.3886",
  "atom": "static-1.5491",
  "avatar-components": "static-1.2897",
  "navigation-messaging": "static-1.8382",
  "redux-thunk": "static-2.83",
  "reference-resolvers": "static-1.8594",
  "commerce-products-lib": "static-1.10757",
  "crm-message-bus": "static-1.43987",
  "growth-data-modal": "static-1.6047",
  "hubspot-apollo-client": "static-1.5288",
  "onboarding-tours-client": "static-1.5519",
  "batch-promise": "static-1.1959",
  "calling-global-api": "static-1.66006",
  "calling-internal-common": "static-1.31736",
  "calling-lifecycle-internal": "static-1.67388",
  "calling-lifecycle-messages": "static-1.59681",
  "conditional-properties-service-client": "static-1.4082",
  "crm-index-visualization-core": "static-1.4675",
  "crm-links": "static-1.6716",
  "crm-pipelines-api-client-types": "static-1.4414",
  "customer-data-objects-ui-components": "static-1.13443",
  "customer-data-properties-shared-msw-handlers": "static-1.10129",
  "customer-data-property-utils": "static-1.8464",
  "external-options-client-types": "static-1.4408",
  "formula-editor": "static-1.14930",
  "framework-data-schema-resolvers": "static-1.7309",
  "google-libphonenumber": "static-1.48",
  "hs-resources": "static-1.608",
  "inbound-db-meta-service-client": "static-1.3741",
  "inbounddb-objects-service-types": "static-1.4491",
  "meetings-icalendar-utils-lib": "static-1.1050",
  "multi-currency-client-types": "static-1.3978",
  "object-builder-ui-client": "static-1.49909",
  "pipeline-validation-client-types": "static-1.4250",
  "property-value-citations": "static-1.3491",
  "pulse": "static-1.1052",
  "smart-data-capture-core": "static-1.350",
  "smart-property-lib": "static-1.8520",
  "tiered-pricing": "static-1.2140",
  "topics-actions-lib": "static-1.588",
  "trial-components-library": "static-1.14293",
  "ui-addon-form-validation": "static-1.11338",
  "zustand": "static-1.88",
  "growth-onboarding-confetti": "static-1.3477",
  "growth-onboarding-next-action-utils": "static-1.2883",
  "navigation-components": "static-1.19055",
  "onboarding-tours-utils": "static-1.1371",
  "ui-shepherd-tracker": "static-1.8068",
  "ui-universal-auth": "static-1.9617",
  "getting-started-shared-tasks-store": "static-1.18577",
  "beacon-keepalive-queue": "static-1.114",
  "opentelemetry-web": "static-1.18",
  "hubspotter-http-shared-msw-handlers": "static-1.10800",
  "usage-tracker-session-replay": "static-1.5413",
  "base-ui": "static-1.26",
  "react-day-picker": "static-1.14",
  "trellis-theming": "static-1.1394",
  "tanstack-virtual": "static-1.42",
  "audio-components": "static-1.6488",
  "FileManagerCore": "static-1.40236",
  "FileManagerImages": "static-1.37888",
  "video-components": "static-1.14327",
  "foundations-components-legacy": "static-1.1680",
  "purchase-motions-api": "static-1.6560",
  "signup-constants": "static-1.19835",
  "signup-ui-url-generator": "static-2.8473",
  "stylex-utils": "static-1.158",
  "usage-tracker-public": "static-1.7538",
  "reactive-lib": "static-1.1136",
  "simple-logging-lib": "static-1.3466",
  "nudge-client-utils": "static-1.3313",
  "chatspot-core": "static-1.23492",
  "growth-onboarding-feedback-components": "static-1.6997",
  "cms-field-types": "static-1.5226",
  "content-icons-ui": "static-1.2417",
  "integrations-lib": "static-1.17295",
  "underscore": "static-1.8",
  "breeze-engine-chat-components": "static-1.981",
  "breeze-engine-core": "static-1.1281",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "markdown-it": "static-1.6",
  "commerce-permissions": "static-1.1190",
  "customer-data-tracking": "static-1.7286",
  "products-iframe-lib": "static-1.8794",
  "products-ui-components-shared-msw-handlers": "static-1.11184",
  "restore-request-side-panel-lib": "static-1.1911",
  "onboarding-data-sync-lib": "static-1.2740",
  "hubspot-apollo-cache": "static-1.747",
  "calling-error-reporting": "static-1.31743",
  "shared-worker-versioning": "static-1.11454",
  "calling-usage-tracker": "static-1.6949",
  "voice-sms-access-library": "static-1.2309",
  "conversations-skeleton-state": "static-1.7602",
  "crm-index-associations-lib": "static-1.6861",
  "framework-data-schema-quick-fetch": "static-1.7214",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10885",
  "redux-toolkit": "static-1.81",
  "sales-views-client-types": "static-1.4672",
  "location-customization-utils-lib": "static-1.10314",
  "bark-lib": "static-1.16943",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.105",
  "crm-properties-common-lib": "static-1.6302",
  "react-codemirror": "static-1.11053",
  "fdsr-migration-layer": "static-1.428",
  "framework-builder-read-service-client": "static-1.4289",
  "persist-promise": "static-1.4116",
  "event-emitter": "static-1.1373",
  "bend-plugin-pulse": "static-1.555",
  "fast-json-patch": "static-1.73",
  "data-agent-kit": "static-1.800",
  "fsm": "static-1.4167",
  "policy-lib": "static-1.7219",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10948",
  "embedded-academy-lib": "static-1.15830",
  "hubs-service-types": "static-1.1677",
  "salesImages": "static-1.672",
  "growth-onboarding-next-action-components": "static-1.2911",
  "user-context-client": "static-1.4922",
  "nest": "static-1.649",
  "unified-auth-core-lib": "static-1.1413",
  "amplitude-session-replay-browser": "static-1.60",
  "breeze-artifacts-sdk": "static-1.672",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.64",
  "urlinator": "static-1.4929",
  "video-embed": "static-1.36817",
  "social-insights-client-types": "static-1.22831",
  "nudge-custom-function-registry": "static-1.3070",
  "nudge-renderer-utils": "static-1.3389",
  "whisper-core-api": "static-1.7531",
  "flux-actions": "static-1.378",
  "integrations-error-boundary-lib": "static-1.14710",
  "integrations-tracking-lib": "static-1.6024",
  "native-integrations-shared-strings": "static-1.8176",
  "redux-observable": "static-1.78",
  "ReduxMessenger": "static-2.10784",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.1131",
  "InboxConnectUtils": "static-4.15745",
  "meetings-connect-utils-lib": "static-1.8029",
  "calling-orchestration-schema": "static-1.37086",
  "crm-record-cards-service-types": "static-1.3834",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16564",
  "browser-eslint": "static-2.57",
  "highcharts": "static-8.114",
  "trellis-story-utils": "static-1.4920",
  "storybook-react": "static-1.43",
  "academy-common-lib": "static-1.15290",
  "outpost": "static-1.4548",
  "universal-page-editor-lib": "static-1.3424",
  "adobe-sign-auth-lib": "static-1.661",
  "ads-unified-auth-lib": "static-1.1759",
  "custom-vendor-connection-lib": "static-1.181",
  "google-sheets-integration-lib": "static-1.1226",
  "microsoft-drive-auth-lib": "static-1.389",
  "surveymonkey-integration-lib": "static-1.758",
  "slack-ui-library": "static-1.10811",
  "hub-http-contrib": "static-1.3440",
  "ui-addon-sales-email": "static-1.5617",
  "academy-service-client": "static-1.4106",
  "croppie": "static-2.10",
  "final-form": "static-1.82",
  "SafeStorage": "static-1.4808",
  "trellis-ecosystem": "static-1.7767",
  "wootric-nps": "static-1.7263",
  "marketplace-ui-apps-core": "static-1.19484",
  "marketplace-ui-common": "static-1.20952",
  "developer-experience-shared-components": "static-1.10951",
  "immutable-less": "static-1.5063",
  "marketplace-ui-client-types": "static-1.18359",
  "ui-addon-integrations-directory-panel": "static-2.8388",
  "ui-extensibility-client-types": "static-1.4330",
  "ai-settings-ui-library": "static-1.8488",
  "nav-meta": "static-1.30692",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1421",
  "apps-service-types": "static-1.4067",
  "oauth-service-types": "static-1.4597",
  "settings-ui-lib": "static-1.12942",
  "simple-data-table": "static-1.3719"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3301",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "client-types": "/client-types/static-1.505",
  "data-fetching-client": "/data-fetching-client/static-1.10059",
  "emoji-mart": "/emoji-mart/static-3.6",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.26392",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6003",
  "hs-test-utils": "/hs-test-utils/static-1.8452",
  "hub-http": "/hub-http/static-1.6623",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10802",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19175",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11904",
  "I18n": "/I18n/static-7.1691",
  "immutable": "/immutable/static-2.88",
  "jasmine-runner": "/jasmine-runner/static-1.6861",
  "payment-link-components": "/payment-link-components/static-1.24332",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.25",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7587",
  "quartz-core": "/quartz-core/static-1.6806",
  "quartz-i18n": "/quartz-i18n/static-1.1262",
  "react": "/react/static-7.202",
  "react-colorpicker": "/react-colorpicker/static-2.10626",
  "react-dlb": "/react-dlb/static-1.92",
  "react-utils": "/react-utils/static-2.5622",
  "reselect": "/reselect/static-3.15",
  "rich-text-lib": "/rich-text-lib/static-1.20466",
  "transmute": "/transmute/static-2.97",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18508",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6041",
  "UIComponents": "/UIComponents/static-3.8850",
  "foundations-assets": "/foundations-assets/static-1.5300",
  "foundations-components": "/foundations-components/static-1.8655",
  "foundations-theming": "/foundations-theming/static-1.4895",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2611",
  "framer-motion": "/framer-motion/static-1.83",
  "metrics-js": "/metrics-js/static-1.9990",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1622",
  "quartz-config": "/quartz-config/static-1.1365",
  "quartz-routing": "/quartz-routing/static-1.1017",
  "quick-fetch": "/quick-fetch/static-1.4191",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1-fix-undefined-routespec-crash.10",
  "rpc-client-utils": "/rpc-client-utils/static-1.5082",
  "sanitize-text": "/sanitize-text/static-1.8571",
  "styled-components": "/styled-components/static-2.100",
  "tanstack-table": "/tanstack-table/static-1.65",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5159",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9943",
  "usage-tracker": "/usage-tracker/static-1.7727",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6144",
  "usage-tracker-core": "/usage-tracker-core/static-1.7577",
  "video-components-external": "/video-components-external/static-1.12325",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3864",
  "quartz-webpack": "/quartz-webpack/static-1.3811",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.665",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.92",
  "customer-data-objects": "/customer-data-objects/static-1.8106",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8332",
  "laboratory-lib": "/laboratory-lib/static-3.7564",
  "onboarding-scopes": "/onboarding-scopes/static-1.6865",
  "seat-types-lib": "/seat-types-lib/static-1.937",
  "ui-addon-opt": "/ui-addon-opt/static-4.8793",
  "HeadJS": "/HeadJS/static-2.811",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3563",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.17",
  "testing-library": "/testing-library/static-1.163",
  "hs-locale-management": "/hs-locale-management/static-1.361",
  "ts-schema": "/ts-schema/static-1.4360",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8340",
  "content-media-capture": "/content-media-capture/static-1.5668",
  "cssUtils": "/cssUtils/static-1.1034",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10245",
  "file-manager-components": "/file-manager-components/static-1.24737",
  "HubStyle": "/HubStyle/static-2.12211",
  "knowledge-content-types": "/knowledge-content-types/static-1.8699",
  "PatternValidationJS": "/PatternValidationJS/static-1.3301",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.512",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10281",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11560",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9508",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10687",
  "video-data-lib": "/video-data-lib/static-1.35983",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4722",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6778",
  "customer-data-properties": "/customer-data-properties/static-1.52877",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19459",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5496",
  "onboarding-tours": "/onboarding-tours/static-1.17304",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8519",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3943",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9492",
  "user-context": "/user-context/static-1.5477",
  "bender-build-tools": "/bender-build-tools/static-1.3513",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.896",
  "hubspotter-http": "/hubspotter-http/static-1.4927",
  "icons": "/icons/static-2.699",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.593",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.573",
  "quartz-auth": "/quartz-auth/static-1.1262",
  "quartz-head": "/quartz-head/static-1.1252",
  "quartz-test": "/quartz-test/static-1.1262",
  "quartz-tracking": "/quartz-tracking/static-1.966",
  "trellis-components": "/trellis-components/static-1.2960",
  "ui-fonts": "/ui-fonts/static-1.1166",
  "usage-tracker-container": "/usage-tracker-container/static-1.7717",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9839",
  "data-token-picker": "/data-token-picker/static-1.17042",
  "FileManagerLib": "/FileManagerLib/static-1.40377",
  "property-translator": "/property-translator/static-1.5794",
  "merchandise-lib": "/merchandise-lib/static-1.283",
  "purchase-motions-components": "/purchase-motions-components/static-1.6557",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6138",
  "react-create-root-preference": "/react-create-root-preference/static-1.88",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-virtualized": "/react-virtualized/static-2.111",
  "ui-images": "/ui-images/static-2.1269",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4924",
  "floating-ui": "/floating-ui/static-1.67",
  "react-aria": "/react-aria/static-1.76",
  "trellis-assets": "/trellis-assets/static-1.2941",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3378",
  "foundations-theming-base": "/foundations-theming-base/static-1.3880",
  "stylex": "/stylex/static-1.45",
  "pdf-js": "/pdf-js/static-2.49",
  "interframe": "/interframe/static-3.5155",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6141",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.198",
  "web-vitals": "/web-vitals/static-1.18",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.492",
  "chirp-fetch": "/chirp-fetch/static-1.2313",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4885",
  "react-flip-move": "/react-flip-move/static-1.82",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5019",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13472",
  "content-media-compositions": "/content-media-compositions/static-2.17479",
  "idb-keyval": "/idb-keyval/static-1.54",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4556",
  "magpie-lib": "/magpie-lib/static-1.5850",
  "magpie-types": "/magpie-types/static-1.5310",
  "media-bridge-lib": "/media-bridge-lib/static-1.19554",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4109",
  "superstore": "/superstore/static-1.5172",
  "feedback-loader": "/feedback-loader/static-1.29972",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9920",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29503",
  "ContentUtils": "/ContentUtils/static-1.69339",
  "fix-webm-duration": "/fix-webm-duration/static-1.33",
  "notification-sounds": "/notification-sounds/static-1.4839",
  "sassPrefix": "/sassPrefix/static-1.302",
  "react-dnd-compat": "/react-dnd-compat/static-1.5025",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2003",
  "copilot-toolkit": "/copilot-toolkit/static-1.12041",
  "poll-commands": "/poll-commands/static-1.3886",
  "atom": "/atom/static-1.5491",
  "avatar-components": "/avatar-components/static-1.2897",
  "navigation-messaging": "/navigation-messaging/static-1.8382",
  "redux-thunk": "/redux-thunk/static-2.83",
  "reference-resolvers": "/reference-resolvers/static-1.8594",
  "commerce-products-lib": "/commerce-products-lib/static-1.10757",
  "crm-message-bus": "/crm-message-bus/static-1.43987",
  "growth-data-modal": "/growth-data-modal/static-1.6047",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5288",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5519",
  "batch-promise": "/batch-promise/static-1.1959",
  "calling-global-api": "/calling-global-api/static-1.66006",
  "calling-internal-common": "/calling-internal-common/static-1.31736",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67388",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59681",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4082",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4675",
  "crm-links": "/crm-links/static-1.6716",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4414",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13443",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10129",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8464",
  "external-options-client-types": "/external-options-client-types/static-1.4408",
  "formula-editor": "/formula-editor/static-1.14930",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7309",
  "google-libphonenumber": "/google-libphonenumber/static-1.48",
  "hs-resources": "/hs-resources/static-1.608",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3741",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4491",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1050",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3978",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49909",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4250",
  "property-value-citations": "/property-value-citations/static-1.3491",
  "pulse": "/pulse/static-1.1052",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.350",
  "smart-property-lib": "/smart-property-lib/static-1.8520",
  "tiered-pricing": "/tiered-pricing/static-1.2140",
  "topics-actions-lib": "/topics-actions-lib/static-1.588",
  "trial-components-library": "/trial-components-library/static-1.14293",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11338",
  "zustand": "/zustand/static-1.88",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3477",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2883",
  "navigation-components": "/navigation-components/static-1.19055",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1371",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8068",
  "ui-universal-auth": "/ui-universal-auth/static-1.9617",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18577",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.114",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10800",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5413",
  "base-ui": "/base-ui/static-1.26",
  "react-day-picker": "/react-day-picker/static-1.14",
  "trellis-theming": "/trellis-theming/static-1.1394",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "audio-components": "/audio-components/static-1.6488",
  "FileManagerCore": "/FileManagerCore/static-1.40236",
  "FileManagerImages": "/FileManagerImages/static-1.37888",
  "video-components": "/video-components/static-1.14327",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1680",
  "purchase-motions-api": "/purchase-motions-api/static-1.6560",
  "signup-constants": "/signup-constants/static-1.19835",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8473",
  "stylex-utils": "/stylex-utils/static-1.158",
  "usage-tracker-public": "/usage-tracker-public/static-1.7538",
  "reactive-lib": "/reactive-lib/static-1.1136",
  "simple-logging-lib": "/simple-logging-lib/static-1.3466",
  "nudge-client-utils": "/nudge-client-utils/static-1.3313",
  "chatspot-core": "/chatspot-core/static-1.23492",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6997",
  "cms-field-types": "/cms-field-types/static-1.5226",
  "content-icons-ui": "/content-icons-ui/static-1.2417",
  "integrations-lib": "/integrations-lib/static-1.17295",
  "underscore": "/underscore/static-1.8",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.981",
  "breeze-engine-core": "/breeze-engine-core/static-1.1281",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "markdown-it": "/markdown-it/static-1.6",
  "commerce-permissions": "/commerce-permissions/static-1.1190",
  "customer-data-tracking": "/customer-data-tracking/static-1.7286",
  "products-iframe-lib": "/products-iframe-lib/static-1.8794",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11184",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1911",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2740",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.747",
  "calling-error-reporting": "/calling-error-reporting/static-1.31743",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11454",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6949",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2309",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6861",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7214",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10885",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "sales-views-client-types": "/sales-views-client-types/static-1.4672",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10314",
  "bark-lib": "/bark-lib/static-1.16943",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.105",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6302",
  "react-codemirror": "/react-codemirror/static-1.11053",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.428",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4289",
  "persist-promise": "/persist-promise/static-1.4116",
  "event-emitter": "/event-emitter/static-1.1373",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.555",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "data-agent-kit": "/data-agent-kit/static-1.800",
  "fsm": "/fsm/static-1.4167",
  "policy-lib": "/policy-lib/static-1.7219",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10948",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15830",
  "hubs-service-types": "/hubs-service-types/static-1.1677",
  "salesImages": "/salesImages/static-1.672",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2911",
  "user-context-client": "/user-context-client/static-1.4922",
  "nest": "/nest/static-1.649",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1413",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.672",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.64",
  "urlinator": "/urlinator/static-1.4929",
  "video-embed": "/video-embed/static-1.36817",
  "social-insights-client-types": "/social-insights-client-types/static-1.22831",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3070",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3389",
  "whisper-core-api": "/whisper-core-api/static-1.7531",
  "flux-actions": "/flux-actions/static-1.378",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14710",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6024",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8176",
  "redux-observable": "/redux-observable/static-1.78",
  "ReduxMessenger": "/ReduxMessenger/static-2.10784",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.1131",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15745",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8029",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37086",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3834",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16564",
  "browser-eslint": "/browser-eslint/static-2.57",
  "highcharts": "/highcharts/static-8.114",
  "trellis-story-utils": "/trellis-story-utils/static-1.4920",
  "storybook-react": "/storybook-react/static-1.43",
  "academy-common-lib": "/academy-common-lib/static-1.15290",
  "outpost": "/outpost/static-1.4548",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3424",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.661",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1759",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.181",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1226",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.389",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.758",
  "slack-ui-library": "/slack-ui-library/static-1.10811",
  "hub-http-contrib": "/hub-http-contrib/static-1.3440",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5617",
  "academy-service-client": "/academy-service-client/static-1.4106",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.82",
  "SafeStorage": "/SafeStorage/static-1.4808",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7767",
  "wootric-nps": "/wootric-nps/static-1.7263",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19484",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20952",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10951",
  "immutable-less": "/immutable-less/static-1.5063",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18359",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8388",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4330",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8488",
  "nav-meta": "/nav-meta/static-1.30692",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1421",
  "apps-service-types": "/apps-service-types/static-1.4067",
  "oauth-service-types": "/oauth-service-types/static-1.4597",
  "settings-ui-lib": "/settings-ui-lib/static-1.12942",
  "simple-data-table": "/simple-data-table/static-1.3719"
}
};
